{
  "v": "5.4.2",
  "fr": 60,
  "ip": 0,
  "op": 88,
  "w": 1176,
  "h": 1176,
  "nm": "Empty State 3",
  "ddd": 0,
  "assets": [
    {
      "id": "comp_0",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 0,
          "nm": "Target",
          "refId": "comp_1",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [588, 588, 0], "ix": 2 },
            "a": { "a": 0, "k": [588, 588, 0], "ix": 1 },
            "s": { "a": 0, "k": [108, 108, 100], "ix": 6 }
          },
          "ao": 0,
          "w": 1176,
          "h": 1176,
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 0,
          "nm": "Mountain",
          "refId": "comp_3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 0.833 },
                  "o": { "x": 0.167, "y": 0.167 },
                  "n": "0p833_0p833_0p167_0p167",
                  "t": 0,
                  "s": [588, 1068, 0],
                  "e": [588, 588, 0],
                  "to": [0, -80, 0],
                  "ti": [0, 80, 0]
                },
                { "t": 27 }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [588, 588, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "w": 1176,
          "h": 1176,
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "Rectangle",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [588, 588, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [196, 196], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.729412019253, 0.933332979679, 0.88627499342, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Rectangle",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_1",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 0,
          "nm": "Bullesye Target",
          "refId": "comp_2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 0.833 },
                  "o": { "x": 0.167, "y": 0.167 },
                  "n": "0p833_0p833_0p167_0p167",
                  "t": 58,
                  "s": [588, 588, 0],
                  "e": [615, 588, 0],
                  "to": [4.5, 0, 0],
                  "ti": [0.16666667163372, 1.66666662693024, 0]
                },
                {
                  "i": { "x": 0.833, "y": 0.833 },
                  "o": { "x": 0.167, "y": 0.167 },
                  "n": "0p833_0p833_0p167_0p167",
                  "t": 60,
                  "s": [615, 588, 0],
                  "e": [587, 578, 0],
                  "to": [-0.16666667163372, -1.66666662693024, 0],
                  "ti": [4.5, 0, 0]
                },
                {
                  "i": { "x": 0.833, "y": 0.833 },
                  "o": { "x": 0.167, "y": 0.167 },
                  "n": "0p833_0p833_0p167_0p167",
                  "t": 61,
                  "s": [587, 578, 0],
                  "e": [588, 588, 0],
                  "to": [-4.5, 0, 0],
                  "ti": [-0.16666667163372, -1.66666662693024, 0]
                },
                { "t": 63 }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [588, 588, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": [0.833, 0.833, 0.833],
                    "y": [0.833, 0.833, 0.833]
                  },
                  "o": {
                    "x": [0.167, 0.167, 0.167],
                    "y": [0.167, 0.167, 0.167]
                  },
                  "n": [
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167"
                  ],
                  "t": 0,
                  "s": [0, 0, 100],
                  "e": [115, 115, 100]
                },
                {
                  "i": {
                    "x": [0.833, 0.833, 0.833],
                    "y": [0.833, 0.833, 0.833]
                  },
                  "o": {
                    "x": [0.167, 0.167, 0.167],
                    "y": [0.167, 0.167, 0.167]
                  },
                  "n": [
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167"
                  ],
                  "t": 14,
                  "s": [115, 115, 100],
                  "e": [100, 100, 100]
                },
                {
                  "i": {
                    "x": [0.833, 0.833, 0.833],
                    "y": [0.833, 0.833, 0.833]
                  },
                  "o": {
                    "x": [0.167, 0.167, 0.167],
                    "y": [0.167, 0.167, 0.167]
                  },
                  "n": [
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167"
                  ],
                  "t": 23,
                  "s": [100, 100, 100],
                  "e": [100, 100, 100]
                },
                {
                  "i": {
                    "x": [0.833, 0.833, 0.833],
                    "y": [0.833, 0.833, 0.833]
                  },
                  "o": {
                    "x": [0.167, 0.167, 0.167],
                    "y": [0.167, 0.167, 0.167]
                  },
                  "n": [
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167"
                  ],
                  "t": 60,
                  "s": [100, 100, 100],
                  "e": [107, 107, 100]
                },
                {
                  "i": {
                    "x": [0.833, 0.833, 0.833],
                    "y": [0.833, 0.833, 0.833]
                  },
                  "o": {
                    "x": [0.167, 0.167, 0.167],
                    "y": [0.167, 0.167, 0.167]
                  },
                  "n": [
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167"
                  ],
                  "t": 64,
                  "s": [107, 107, 100],
                  "e": [100, 100, 100]
                },
                { "t": 69 }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1176,
          "h": 1176,
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "Top",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [591, 223.418, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [0, -11.236],
                        [0, 11.234]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.062744997442, 0.419607996941, 0.466666996479, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "ml2": { "a": 0, "k": 4, "ix": 8 },
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Top",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "n": ["0p833_0p833_0p167_0p167"],
                    "t": 20,
                    "s": [100],
                    "e": [0]
                  },
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "n": ["0p833_0p833_0p167_0p167"],
                    "t": 43,
                    "s": [0],
                    "e": [15]
                  },
                  { "t": 49 }
                ],
                "ix": 1
              },
              "e": { "a": 0, "k": 100, "ix": 2 },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 2,
              "nm": "Trim Paths 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "Left",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [432, 825, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [-100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [15.16, 15.16],
                        [-15.5, -15.5]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.062744997442, 0.419607996941, 0.466666996479, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "ml2": { "a": 0, "k": 4, "ix": 8 },
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Left",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "n": ["0p833_0p833_0p167_0p167"],
                    "t": 20,
                    "s": [100],
                    "e": [0]
                  },
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "n": ["0p833_0p833_0p167_0p167"],
                    "t": 43,
                    "s": [0],
                    "e": [15]
                  },
                  { "t": 49 }
                ],
                "ix": 1
              },
              "e": { "a": 0, "k": 100, "ix": 2 },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 2,
              "nm": "Trim Paths 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "Right",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [750, 825, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [15.16, 15.16],
                        [-15.5, -15.5]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.062744997442, 0.419607996941, 0.466666996479, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "ml2": { "a": 0, "k": 4, "ix": 8 },
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Right",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "n": ["0p833_0p833_0p167_0p167"],
                    "t": 20,
                    "s": [100],
                    "e": [0]
                  },
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "n": ["0p833_0p833_0p167_0p167"],
                    "t": 43,
                    "s": [0],
                    "e": [15]
                  },
                  { "t": 49 }
                ],
                "ix": 1
              },
              "e": { "a": 0, "k": 100, "ix": 2 },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 2,
              "nm": "Trim Paths 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_2",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "O.Shadow",
          "cl": "Shadow",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 6, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [753, 540, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 30.38],
                        [30.38, 0]
                      ],
                      "o": [
                        [30.38, 0],
                        [0, -30.38],
                        [0, 0]
                      ],
                      "v": [
                        [-27.5, 55],
                        [27.5, 0],
                        [-27.5, -55]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "O.Shadow",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "cl": "Shadow"
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "Bullseye",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [588.008, 541.704, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": [0.833, 0.833, 0.833],
                    "y": [0.833, 0.833, 0.833]
                  },
                  "o": {
                    "x": [0.167, 0.167, 0.167],
                    "y": [0.167, 0.167, 0.167]
                  },
                  "n": [
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167"
                  ],
                  "t": 3,
                  "s": [0, 0, 100],
                  "e": [237, 237, 100]
                },
                {
                  "i": {
                    "x": [0.833, 0.833, 0.833],
                    "y": [0.833, 0.833, 0.833]
                  },
                  "o": {
                    "x": [0.167, 0.167, 0.167],
                    "y": [0.167, 0.167, 0.167]
                  },
                  "n": [
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167"
                  ],
                  "t": 15,
                  "s": [237, 237, 100],
                  "e": [100, 100, 100]
                },
                { "t": 23 }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, -8.38],
                        [8.38, 0],
                        [0, 8.38],
                        [-8.38, 0]
                      ],
                      "o": [
                        [8.38, 0],
                        [0, 8.38],
                        [-8.38, 0],
                        [0, -8.38],
                        [0, 0]
                      ],
                      "v": [
                        [0.004, -15.176],
                        [15.174, 0.004],
                        [0.004, 15.174],
                        [-15.176, 0.004],
                        [0.004, -15.176]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [1, 0.454939991236, 0.454939991236, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Bullseye",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "O.White",
          "cl": "White",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [588, 541.695, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": [0.833, 0.833, 0.833],
                    "y": [0.833, 0.833, 0.833]
                  },
                  "o": {
                    "x": [0.167, 0.167, 0.167],
                    "y": [0.167, 0.167, 0.167]
                  },
                  "n": [
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167"
                  ],
                  "t": 0,
                  "s": [0, 0, 100],
                  "e": [149, 149, 100]
                },
                {
                  "i": {
                    "x": [0.833, 0.833, 0.833],
                    "y": [0.833, 0.833, 0.833]
                  },
                  "o": {
                    "x": [0.167, 0.167, 0.167],
                    "y": [0.167, 0.167, 0.167]
                  },
                  "n": [
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167",
                    "0p833_0p833_0p167_0p167"
                  ],
                  "t": 18,
                  "s": [149, 149, 100],
                  "e": [100, 100, 100]
                },
                { "t": 29 }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [74, 74], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "O.White",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "cl": "White"
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "Path",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [588.001, 540.107, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [13.1, 0],
                        [0, -30.17],
                        [-30.18, 0],
                        [0, 30.18],
                        [7.81, 9.45]
                      ],
                      "o": [
                        [0, 0],
                        [-9.41, -7.69],
                        [-30.18, 0],
                        [0, 30.18],
                        [30.17, 0],
                        [0, -13.21],
                        [0, 0]
                      ],
                      "v": [
                        [42.135, -34.785],
                        [34.535, -42.335],
                        [0.005, -54.635],
                        [-54.635, -0.005],
                        [0.005, 54.635],
                        [54.635, -0.005],
                        [42.135, -34.785]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [1, 0.454939991236, 0.454939991236, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Path",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_3",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Oval",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 21, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [898.297, 1334.108, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.39, -75.89],
                        [0, 57.13],
                        [57.12, 0]
                      ],
                      "o": [
                        [57.12, 0],
                        [0, -57.12],
                        [1.44, 97.62]
                      ],
                      "v": [
                        [-51.716, 103.428],
                        [51.714, -0.002],
                        [-51.716, -103.432]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.196078002453, 0.741176009178, 0.815685987473, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Oval",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "Oval",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 21, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [588, 1334.108, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [206.865, 206.865], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.196078002453, 0.741176009178, 0.815685987473, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [600, 600], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Oval",
              "np": 2,
              "cix": 2,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 3600,
          "st": 0,
          "bm": 0
        }
      ]
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 3,
      "nm": "▽ Arrow",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [783, 339, 0], "ix": 2 },
        "a": { "a": 0, "k": [195, 195, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "ip": 0,
      "op": 3600,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Path 2",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [156.195, 244.696, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "n": [
                "0p833_0p833_0p167_0p167",
                "0p833_0p833_0p167_0p167",
                "0p833_0p833_0p167_0p167"
              ],
              "t": 36,
              "s": [41, 41, 100],
              "e": [100, 100, 100]
            },
            { "t": 50 }
          ],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-26.366, 26.215],
                    [66.364, -66.548]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.062744997442, 0.419607996941, 0.466666996479, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 4, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [600, 600], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Path 2",
          "np": 2,
          "cix": 2,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.833], "y": [0.833] },
                "o": { "x": [0.167], "y": [0.167] },
                "n": ["0p833_0p833_0p167_0p167"],
                "t": 49,
                "s": [100],
                "e": [0]
              },
              { "t": 57.16015625 }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.833], "y": [0.833] },
                "o": { "x": [0.167], "y": [0.167] },
                "n": ["0p833_0p833_0p167_0p167"],
                "t": 49.682,
                "s": [100],
                "e": [33.192]
              },
              {
                "i": { "x": [0.833], "y": [0.833] },
                "o": { "x": [0.167], "y": [0.167] },
                "n": ["0p833_0p833_0p167_0p167"],
                "t": 58,
                "s": [33.192],
                "e": [61]
              },
              {
                "i": { "x": [0.833], "y": [0.833] },
                "o": { "x": [0.167], "y": [0.167] },
                "n": ["0p833_0p833_0p167_0p167"],
                "t": 59.881,
                "s": [61],
                "e": [64]
              },
              { "t": 66 }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 3600,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Feather",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [286.353, 75.553, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "n": [
                "0p833_0p833_0p167_0p167",
                "0p833_0p833_0p167_0p167",
                "0p833_0p833_0p167_0p167"
              ],
              "t": 56.801,
              "s": [0, 0, 100],
              "e": [100, 100, 100]
            },
            { "t": 64 }
          ],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-5.565, 0.942],
                    [-5.045, 10.122],
                    [5.565, -0.948],
                    [5.045, -10.118]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.196078002453, 0.741176009178, 0.815685987473, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [600, 600], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Feather",
          "np": 2,
          "cix": 2,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 3600,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Feather",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [325.812, 115.082, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "n": [
                "0p833_0p833_0p167_0p167",
                "0p833_0p833_0p167_0p167",
                "0p833_0p833_0p167_0p167"
              ],
              "t": 56.801,
              "s": [0, 0, 100],
              "e": [100, 100, 100]
            },
            { "t": 64.80078125 }
          ],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.948, 5.565],
                    [-10.118, 5.045],
                    [0.942, -5.565],
                    [10.122, -5.045]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.196078002453, 0.741176009178, 0.815685987473, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [600, 600], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Feather",
          "np": 2,
          "cix": 2,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 3600,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 0,
      "nm": "Mask",
      "refId": "comp_0",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [588, 588, 0], "ix": 2 },
        "a": { "a": 0, "k": [588, 588, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "hasMask": true,
      "masksProperties": [
        {
          "inv": false,
          "mode": "a",
          "pt": {
            "a": 1,
            "k": [
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "n": "0p833_0p833_0p167_0p167",
                "t": 0,
                "s": [
                  {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [588, 588],
                      [588, 588],
                      [588, 588],
                      [588, 588]
                    ],
                    "c": true
                  }
                ],
                "e": [
                  {
                    "i": [
                      [324.743, 0],
                      [0, -324.743],
                      [-324.743, 0],
                      [0, 324.743]
                    ],
                    "o": [
                      [-324.743, 0],
                      [0, 324.743],
                      [324.743, 0],
                      [0, -324.743]
                    ],
                    "v": [
                      [588, 0],
                      [0, 588],
                      [588, 1176],
                      [1176, 588]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "n": "0p833_0p833_0p167_0p167",
                "t": 17,
                "s": [
                  {
                    "i": [
                      [324.743, 0],
                      [0, -324.743],
                      [-324.743, 0],
                      [0, 324.743]
                    ],
                    "o": [
                      [-324.743, 0],
                      [0, 324.743],
                      [324.743, 0],
                      [0, -324.743]
                    ],
                    "v": [
                      [588, 0],
                      [0, 588],
                      [588, 1176],
                      [1176, 588]
                    ],
                    "c": true
                  }
                ],
                "e": [
                  {
                    "i": [
                      [271.724, 0],
                      [0, -271.724],
                      [-271.724, 0],
                      [0, 271.724]
                    ],
                    "o": [
                      [-271.724, 0],
                      [0, 271.724],
                      [271.724, 0],
                      [0, -271.724]
                    ],
                    "v": [
                      [588, 96],
                      [96, 588],
                      [588, 1080],
                      [1080, 588]
                    ],
                    "c": true
                  }
                ]
              },
              { "t": 32 }
            ],
            "ix": 1
          },
          "o": { "a": 0, "k": 100, "ix": 3 },
          "x": { "a": 0, "k": 0, "ix": 4 },
          "nm": "Mask 1"
        }
      ],
      "w": 1176,
      "h": 1176,
      "ip": 0,
      "op": 3600,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
